import UnderlineTabBar from '@components/UnderlineTabBar';
import { TEMPLATE_TABS, TemplateTabEnum } from './templateTabs';

export type TemplateTabChip = {
  label: string;
  variant?: 'count' | 'optional';
};

type Props = {
  activeTab: TemplateTabEnum;
  chips?: Partial<Record<TemplateTabEnum, TemplateTabChip>>;
  onChange: (tab: TemplateTabEnum) => void;
};

const TemplateTabBar = ({ activeTab, chips = {}, onChange }: Props) => (
  <UnderlineTabBar
    tabs={TEMPLATE_TABS.map((tab) => ({
      ...tab,
      chip: chips[tab.value]
    }))}
    activeTab={activeTab}
    onChange={onChange}
    ariaLabel="Inspection template sections"
    idPrefix="template"
  />
);

export default TemplateTabBar;
